import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router, ActivatedRoute } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import { AsyncLocalStorage } from 'angular-async-local-storage';

import { AuthService } from './../auth/auth.service';
import { AlertService } from './../alert/alert.service';
import { Result } from '../auth/Result';
import { Alert } from '../alert/Alert';
import { User } from './../auth/User';

@Injectable()
export class AuthGuard implements CanActivate {

  private tokenUser: string;

  private user: any;

  constructor(
    private authService: AuthService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private alert: AlertService,
    private localStorage: AsyncLocalStorage
  ) {
    this.localStorage.getItem('token').subscribe((token) => {
      this.setTokenUser(token);
    },);

    this.localStorage.getItem('user').subscribe((user) => {
      this.user = user;
      this.authService.setUser(user);
    });
  }

  public setTokenUser(token: string): void {
    this.tokenUser = token;
  }

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> | boolean {

    if(this.authService.getUserAuthentic()) {
      return true;
    }

    if(!this.tokenUser) {
      this.alert.swalError('Falhou!', 'Não foi possível validar sua sessão. Faça o login novamente.')
      this.router.navigate(["/auth"]);

      return false;
    }
    
    return true;
  }
}


// WEBPACK FOOTER //
// /var/www/minhaloga-cliente/src/app/guards/auth.guard.ts